
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class FaceVerifyDialog extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Boolean, default: false }) cancelBtnShow!: boolean;
  @Prop({ type: Boolean, default: true }) okBtnShow!: boolean;
  @Prop({ type: String, default: "" }) title!: string; //标题
  @Prop({ type: String, default: "" }) showText!: string; //提示语
  @Prop({ type: String, default: "取消" }) cancelText!: string; //按钮文字
  @Prop({ type: String, default: "确认" }) okText!: string; //按钮文字
  @Prop({ type: String, default: "#525FFF" }) mainColor!: String; //主色调

  get showMe() {
    return this.show;
  }

  created() {
    //
  }
  cancel() {
    this.$emit("cancel");
  }
  ok() {
    this.$emit("ok");
    //
  }

  //关闭
  close() {
    this.$emit("cancel");
  }
}
